export default {
  common: {
    esg: {
      category: 'Phân loại',
      environment: 'Môi trường',
      society: 'Xã hội',
      governance: 'Quản trị',
      other: 'khác',
      comprehensive: 'Tổng',
      // basic: '',
    },
    btn: {
      cancel: 'Hủy bỏ',
      add: 'Thêm',
      create: 'Tạo',
      update: 'Cập nhật',
      apply: 'Áp dụng',
      close: 'Đóng',
      create_new: 'Tạo mới',
      edit: 'Chỉnh sửa',
      detail: 'Chi tiết',
      view_detail: 'Chi tiết',
      delete: 'Xoá',
      change: 'Thay đổi',
      confirm: 'Xác nhận',
      clear: 'Đặt lại',
      download: 'Tải xuống',
      save: 'Lưu',
      register: 'Đăng ký',
      check_answer: 'Kiểm tra câu trả lời',
      score_card_list: 'Danh sách bảng điểm',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: 'Tải xuống hàng loạt',
    },
    link: {
      delete: 'Xoá',
      back: 'Quay lại',
    },
    sentence: {
      back_to_login: 'Quay lại đăng nhập',
      back_to_dashboard: 'Quay lại bảng điều khiển',
      not_applicable: 'Không áp dụng*',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'Phiếu câu hỏi',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'Chọn phiếu câu hỏi',
      target_year: 'Năm',
      target_year_text: 'Chọn năm',
      target_company: 'Công ty',
      target_company_text: 'Chọn công ty',
      total: 'Tất cả: {total}',
    },
    label: {
      required: 'Bắt buộc',
      optional: 'Tùy chọn',
      year: 'Năm',
    },
    form: {
      search_word: {
        label: 'Tìm kiếm từ miễn phí',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: 'Ngày phát hành',
      evaluation_expires_date: 'Ngày có hiệu lực',
      answer_expires_date: 'Hạn cuối',
      // last_updated_date: '',
    },
    error: {
      code_0005: 'Xác thực không thành công. Vui lòng đăng nhập lại',
      code_0007: 'Câu hỏi này là bắt buộc',
      code_5001: 'Không tìm được trang',
      code_0001: 'Đã gửi phiếu câu hỏi mới nhất',
      code_0002: 'Cập nhật không thành công vì dữ liệu mới nhất đã được cập nhật từ thiết bị khác. Vui lòng tải lại và thử cập nhật lại.',
      code_0003: 'Không xóa được tệp. Vui lòng xóa sau khi trả lời ít nhất một câu hỏi.',
      code_0006: 'Người dùng đã được đăng ký',
      code_0004: 'Tệp này vượt quá kích cỡ tệp có thể tải lên. Vui lòng lưu ý rằng kích cỡ tệp từ 50MB trở xuống.',
      code_9999: 'Đã xảy ra lỗi không mong muốn',
    },
    evaluation: {
      title: 'Đánh giá yêu cầu',
      dashboard: 'Bảng điều khiển',
      analysis: 'Phân tích',
      list: 'Danh sách công ty',
    },
    dashboard: {
      title: 'Bảng điều khiển',
    },
    upload: {
      title: 'Phiếu câu hỏi',
      common: 'Chung',
    },
    scorecard: {
      title: 'Thẻ điểm',
      list: 'Danh sách',
      detail: 'Chi tiết',
      scorecard_detail: 'Chi tiết bảng điểm',
      answer_preview: 'Xem trước câu trả lời',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: 'Kế hoạch cải thiện',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: 'Phân tích bổ sung',
    },
    settings: {
      title: 'Cài đặt',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: 'Câu hỏi thường gặp',
    },
    logout: {
      title: 'Đăng xuất',
    },
    industry: {
      type_1: 'Nông, lâm, ngư nghiệp',
      type_2: 'Khai thác mỏ, Khai thác đá và Khai thác sỏi',
      type_3: 'Khai thác mỏ, Khai thác đá và Khai thác sỏi',
      type_4: 'Ngành sản xuất (Sắt, Thép, Kim loại màu, Sản phẩm kim loại)',
      type_5: 'Ngành sản xuất (Máy móc, Thiết bị, Đồ điện tử, v.v.)',
      type_6: 'Ngành sản xuất (Thực phẩm, Đồ uống, Thuốc lá, v.v.)',
      type_7: 'Ngành sản xuất (Bột giấy, Giấy, Sản phẩm từ giấy)',
      type_8: 'Ngành sản xuất (Gỗ, Chế biến sản phẩm từ gỗ)',
      type_9: 'Ngành sản xuất (Ngành hóa chất, bao gồm cả Dược phẩm, Ngành dệt may)',
      type_10: 'Ngành sản xuất (Dầu khí, Than, Cao su, Nhựa, v.v.)',
      type_11: 'Ngành sản xuất (Ngành in)',
      type_12: 'Ngành sản xuất khác (Khác)',
      type_13: 'Cấp điện, gas, sưởi',
      type_14: 'Cấp điện, gas, sưởi',
      type_15: 'Ngành vận tải và kho bãi',
      type_16: 'Ngành bán buôn và bán lẻ',
      type_17: 'Ngành tài chính và bảo hiểm',
      type_18: 'Ngành bất động sản',
      type_19: 'Trường học (bao gồm Trường mẫu giáo và Nhà trẻ)',
      type_20: 'Ngành dịch vụ lưu trú và ăn uống',
      type_21: 'Ngành dịch vụ liên quan đến cuộc sống (Giặt là, Cắt tóc, Làm đẹp, Nhà tắm, v.v.)',
      type_22: 'Ngành y tế và phúc lợi',
      type_23: 'Ngành xử lý và tái chế rác thải',
      type_24: 'Ngành bảo trì ô tô',
      type_25: 'Chính quyền địa phương, Cơ quan công quyền, v.v.',
      type_26: 'Khác',
    },
    scale: {
      a: '1〜29 người',
      b: '30〜99 người',
      c: '100〜499 người',
      d: '500〜999 người',
      e: '1000〜4999 người',
      f: 'Hơn 5000 người',
    },
    sales_amount: {
      under_1million: '~1 triệu USD',
      under_10million: '1~10 triệu USD',
      under_100million: '10~100 triệu USD',
      under_1billion: '100 triệu~1 tỷ USD',
      under_10billion: '1~10 tỷ USD',
      over_10billion: '10 tỷ~ USD',
      not_disclose: 'Không muốn tiết lộ',
    },
    progress: 'Đang tiến hành',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'Bản phân tích',
    help: 'Trợ giúp',
    user_display_mode: {
      my_assessment: 'Đánh giá của tôi',
      supply_chain_assessment: 'Đánh giá chuỗi cung ứng',
    },
    buyer: 'Công ty bên mua',
    supplier: 'Nhà cung cấp',
    error_page: {
      section_one: 'Không tìm được trang',
      section_two: 'Vui lòng kiểm tra URL',
      to_dashboard: 'Quay lại bảng điều khiển',
    },
    priority: {
      good: 'Tốt',
      high: 'Cao',
      medium: 'Trung bình',
      low: 'Thấp',
    },
    priority_full_name: {
      high: 'Nguy cơ cao',
      medium: 'Nguy cơ vừa',
      low: 'Nguy cơ thấp',
    },
    faq: {
      how_to_use_csv_head: 'Để mở tệp CSV đã tải xuống trong Excel, vui lòng làm theo hướng dẫn bên dưới.',
      how_to_use_csv_body_01: '1. Mở một sổ Excel mới trống.',
      how_to_use_csv_body_02: '2. Trên tab "Dữ liệu", nhấp vào "Từ văn bản hoặc CSV".',
      how_to_use_csv_body_03: '3. Chọn tệp CSV và nhấp vào "Nhập".',
      how_to_use_csv_body_04: '4. Xác nhận rằng tệp đã được nhập chính xác.',
      how_to_use_csv_body_05: '5. Chọn "Tải".',
      how_to_use_csv_note: '※ Quy trình có thể khác nhau tùy thuộc vào hệ điều hành và phiên bản Microsoft Excel được sử dụng.',
    },
    answer_display_status: {
      unanswered: 'Chưa bắt đầu',
      temporarily_saved: 'Đang trong tiến trình',
      submitted: 'Đã gửi',
      score_rated: 'Đã đánh giá',
      ended: 'Đã đóng',
    },
    all: 'Tất cả',
    count: {
      // question: '',
      company: ' Các công ty',
      unit: 'các mục',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'Trạng thái',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: 'Nhập',
      half_digits: 'Số nửa rộng',
    },
  },
};
